




































































import {Component, Prop, Watch} from "vue-property-decorator";
import {WarehouseStore} from "@/modules/warehouses/store";
import {Warehouse} from "@/interfaces/entity";
import {EmployeeType, PartnerType, SiteTargetType} from "@/enums/type";
import {StockOutDeliveryParams} from "@/modules/warehouses/params";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import {debounce, union, difference} from 'lodash';
import PLDeliveryPrint from "@/modules/pickinglistdeliveries/shared/component/PickingListDeliveryPrint/index.vue";
import {PickingListDeliveryStore} from "@/modules/pickinglistdeliveries";
import {getPublicPath} from "@/shared/services/helper/utils";
import PartnerSelector from "@/shared/components/PartnerSelector/index.vue";
import EmployeeSelector from "@/shared/components/EmployeeSelector/index.vue";
import DetailLadingPrint from "@/modules/ladings/Print/components/Detail.vue";
import {Options} from "@/plugins/print/lib/print";
import {LadingStore} from "@/modules/ladings/store";
import LadingStatusLabel from "@/shared/components/LadingStatusLabel/index.vue";
import LadingPrintA6 from "@/modules/ladings/Print/LabelA6/index.vue";
import AInputBarCode from "@/shared/components/InputBarCode/index.vue";
import WarehouseSuggestDeliveryTable
    from "@/modules/warehouses/shared/components/WarehouseSuggestDeliveryTable/index.vue";
import cloneDeep from 'lodash/cloneDeep'
import {singlePickingListDeliveryByCode} from "@/modules/pickinglistdeliveries/services";

const form = {
    warehouseIds: [],
    deliveryTargetRowGuid: undefined,
    pickingListCode: undefined
};
@Component({
    name: "CreateDeliveryForPartner",
    components: {
        WarehouseSuggestDeliveryTable,
        AInputBarCode,
        LadingPrintA6,
        LadingStatusLabel,
        DetailLadingPrint,
        EmployeeSelector,
        PartnerSelector,
        PLDeliveryPrint
    }
})
export default class extends mixins(CommonMixin) {
    @Prop() readonly code!: string;
    columns = [
        {
            title: "STT",
            dataIndex: "stt",
            key: "stt",
            width: 50
        },
        {
            title: "Mã vận đơn",
            dataIndex: "billLading.ladingCode",
            key: "ladingCode",
            width: 150,
            ellipsis: true
        },
        {
            title: "Mã vận đơn ĐT",
            dataIndex: "billLading.partnerLadingCode",
            key: "partnerLadingCode",
            width: 150,
            ellipsis: true
        },
        {
            title: "SĐT người nhận",
            dataIndex: "billLading.locationTo.phoneNumber",
            key: "locationToPhoneNumber",
            width: 150,
            ellipsis: true
        },
        {
            title: "Tên người nhận",
            dataIndex: "ladingRowGuid",
            key: "locationToName",
            scopedSlots: {customRender: "locationToName"},
            width: 150,
            ellipsis: true
        },
        {
            title: "Địa chỉ nhận",
            dataIndex: "ladingRowGuid",
            key: "locationToAddress",
            scopedSlots: {customRender: "locationToAddress"},
            width: 500,
            ellipsis: true
        },
        {
            title: "TL(g)",
            dataIndex: "ladingRowGuid",
            key: "ladingWeight",
            scopedSlots: {customRender: "ladingWeight"},
            width: 100,
            ellipsis: true
        },
        {
            title: "SK",
            dataIndex: "ladingRowGuid",
            key: "ladingBoxQuantity",
            scopedSlots: {customRender: "ladingBoxQuantity"},
            width: 80,
            ellipsis: true
        },
        {
            title: "Dịch vụ",
            dataIndex: "billLading.freightService.serviceCode",
            key: "ladingFreightService",
            width: 100,
            ellipsis: true
        },
        {
            title: "DV_GTGT",
            dataIndex: "billLading.freightServiceAdds",
            key: "ladingFreightServiceAdd",
            scopedSlots: {customRender: 'ladingFreightServiceAdd'},
            width: 120,
            ellipsis: true
        },
        {
            title: "Thu tiền NN",
            dataIndex: "ladingRowGuid",
            key: "ladingCOD",
            scopedSlots: {customRender: "ladingCOD"},
            width: 150,
            ellipsis: true
        },
        {
            title: "Trạng thái",
            dataIndex: "ladingRowGuid",
            key: "ladingStatus",
            scopedSlots: {customRender: "ladingStatus"},
            width: 180,
            ellipsis: true
        }
    ];
    printObj = {
        id: "picking-list-delivery-print",
        popTitle: 'Logistic',
        extraCss: `${getPublicPath()}assets/css/print.css`,
    };
    printObjLading: Options = {
        id: 'print-lading-list',
        popTitle: 'Logistic',
        extraCss: `${getPublicPath()}assets/css/print.css`
    };
    PartnerType = PartnerType;
    EmployeeType = EmployeeType;
    ladingCode = "";
    partnerLadingCode = "";
    SiteTargetType = SiteTargetType;
    stockOutDeliveryParams = new StockOutDeliveryParams();
    form = cloneDeep(form);
    pickingListDeliveryId = null;
    isUpdatePartnerLadingCode = false;
    warehouse?: Warehouse = undefined;
    isSubmitting = false;

    get title() {
        return this.code ? `Thêm đơn vào bảng kê ${this.code}` : "Phân công phát đối tác";
    }

    async created() {
        WarehouseStore.clearWarehouses();
        if (this.code) {
            const pickingList = await this.singlePickingListByCode(this.code);
            this.form.deliveryTargetRowGuid = pickingList.targetRowGuid;
            this.form.pickingListCode = this.code as any;
        }
    }

    get totalLading() {
        return WarehouseStore.ids.length;
    }

    get warehouses() {
        return WarehouseStore.ids.map((id: number, index: number) => {
            const warehouse = WarehouseStore.data[id];
            warehouse['stt'] = index + 1;
            return warehouse;
        });
    }

    get selectedRowLadings() {
        return this.form.warehouseIds
            .map((id: number) => WarehouseStore.data[id])
            .map((warehouse: Warehouse) => warehouse.billLading?.rowGuid);
    }

    @Watch("form.deliveryTargetRowGuid")
    async onDeliveryTargetRowGuid(val: any, oldVal: any) {
        this.form = this.code ? {...this.form, warehouseIds: [], deliveryTargetRowGuid: val} : {...form, deliveryTargetRowGuid: val};
        this.ladingCode = "";
        if (!val) {
            WarehouseStore.clearWarehouses();
            return;
        }
        try {
            this.stockOutDeliveryParams = {...new StockOutDeliveryParams(), deliveryTargetRowGuid: val};
            await WarehouseStore.listWarehouseByLadingDelivery(this.stockOutDeliveryParams);
        } catch (e) {
            this.$message.error({content: e.response?.data?.message || "Đã xảy ra lỗi"})
        }
    }

    onChangeLadingCode($evt: any) {
        const ladingCode = $evt.target.value;
        if (!ladingCode) return;
        if (!this.form.deliveryTargetRowGuid) {
            this.$message.error("Chọn đối tác phát");
            return;
        }
        this.handleChangeLadingCode(ladingCode, this);
    }

    handleChangeLadingCode = debounce(async (ladingCode: string, vm: any) => {
        try {
            vm.warehouse = await WarehouseStore.scanBillLadingStockOut(ladingCode);
            if (vm.form.deliveryTargetRowGuid !== vm.getProp(vm.warehouse, 'billLading.deliveryTargetSuggestRowGuid')) {
                vm.warehouse['exception'] = true;
                WarehouseStore.addWarehouse({payload: vm.warehouse, toTop: true});
            } else {
                WarehouseStore.addWarehouse({payload: vm.warehouse});
            }
            if (!vm.isUpdatePartnerLadingCode) {
                vm.form.warehouseIds = union(vm.form.warehouseIds, [vm.warehouse.id]) as any;
            } else {
                (vm.$refs.partnerLadingCode as any).focus();
            }
        } catch (e) {
            vm.$message.error(`${e.response?.data?.message || ""}`);
        } finally {
            if (!vm.isUpdatePartnerLadingCode) {
                vm.ladingCode = "";
            }
        }
    });

    async onChangePartnerLadingCode($evt: any) {
        const partnerLadingCode = $evt.target.value;
        if (!partnerLadingCode) return;
        if (!this.ladingCode || !this.warehouse) {
            this.$message.error("Quét hoặc nhập mã vận đơn và enter");
            return;
        }
        if (!this.form.deliveryTargetRowGuid) {
            this.$message.error("Chọn đối tác phát");
            return;
        }
        if (this.warehouse && this.ladingCode !== this.warehouse?.billLading?.ladingCode) {
            this.$message.error("Quét hoặc nhập mã vận đơn và enter");
            return;
        }
        try {
            await WarehouseStore.updatePartnerLadingCode({
                ladingCode: this.ladingCode,
                partnerLadingCode: partnerLadingCode
            });
            if (this.warehouse) {
                this.form.warehouseIds = union(this.form.warehouseIds, [this.warehouse?.id]) as any;
            }
        } catch (e) {
            this.$message.error(`${e.response?.data?.message || ""}`);
        } finally {
            this.ladingCode = "";
            this.partnerLadingCode = "";
            this.warehouse = undefined;
            (this.$refs.ladingCode as any).focus();
        }
    }

    async stockOutDelivery() {
        if (!this.isValidStockOut()) return;
        try {
            this.isSubmitting = true;
            const pickingListDelivery =
                this.code
                    ? await WarehouseStore.addBillToPickingListDeliveryPartner(this.form)
                    : await WarehouseStore.stockOutDeliveryPartner(this.form);
            this.$message.success("Xuất kho thành công");
            PickingListDeliveryStore.addPickingListDelivery(pickingListDelivery);
            this.pickingListDeliveryId = pickingListDelivery.id;
            this.resetForm();
            (this.$refs.btnPrint as any).$el.click();
            // this.confirmPrintLading();
        } catch (e) {
            this.$message.error({content: e.response?.data?.message || "Đã có lỗi"})
        } finally {
            this.isSubmitting = false;
        }
    }

    acceptLadings() {
        const removeWarehouses = difference(WarehouseStore.ids, this.form.warehouseIds);
        WarehouseStore.deleteWarehouse(removeWarehouses);
    }

    isValidStockOut() {
        if (!this.form.warehouseIds.length) {
            this.$message.error({content: "Chọn vận đơn để xuất kho"});
            return false;
        }
        return true;
    }

    onSelectChange(selectedRowKeys: number[]) {
        this.form.warehouseIds = selectedRowKeys as any;
    }

    confirmPrintLading() {
        this.$confirm({
            title: 'Bạn có muốn in vận đơn ?',
            onOk: async () => {
                await LadingStore.listLadingByRowGuid(this.selectedRowLadings);
                this.printLading();
                this.form = {...form};
            },
            onCancel: () => {
                console.log('Cancel');
                this.form = {...form};
            },
        });
    }

    printLading() {
        (this.$refs.btnPrintLading as any).$el.click();
    }

    changeIsUpdatePartnerLadingCode(e) {
        this.isUpdatePartnerLadingCode = e.target.checked;
    }

    resetForm() {
        this.form = this.code ? { ...this.form, warehouseIds: [] } : cloneDeep(form);
    }

    async singlePickingListByCode(code) {
        try {
            const { data } = await singlePickingListDeliveryByCode(code);
            return data.data;
        } catch (e) {
            this.$message.error(e?.response?.data?.message || "Đã xảy ra lỗi");
        }
    }
}
